import { Box, Button, List, ListItem, styled } from '@mui/material';

export const Root = styled(Box)<{ disabled?: boolean }>(({ disabled }) => ({
  display: 'flex',
  flexDirection: 'column',
  ...(disabled && {
    cursor: 'not-allowed',
    '& *': {
      cursor: 'not-allowed',
    },
  }),
  '& > * + *': {
    marginTop: '8px',
  },
}));

export const DropdownContainer = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  minWidth: '150px',
  height: '46px',
  borderRadius: '4px',
  cursor: 'pointer',
  transition: '0.3s',
}));

export const DropdownList = styled(Box)(({ theme }) => ({
  width: '100%',
  minWidth: '200px',
  maxWidth: '100%',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  boxShadow: '0 6px 17px 0 rgba(0, 0, 0, 0.1)',
  padding: '12px',
  paddingBottom: '14px',
  maxHeight: '360px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const OptionsList = styled(List)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  maxHeight: '250px',
  overflowY: 'auto',
  padding: 0,
}));

export const OptionItem = styled(ListItem)(({ theme }) => ({
  cursor: 'pointer',
  padding: 0,
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const CreateButton = styled(Button)(() => ({
  marginTop: '8px',
  width: '100%',
}));

export const SelectedValues = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const SelectedValue = styled(Box)(({ theme }) => ({
  position: 'relative',
  textDecoration: 'none',
  WebkitUserDrag: 'none',
  display: 'block',

  '& > svg': {
    position: 'absolute',
    top: '4px',
    right: '4px',
    cursor: 'pointer',
    zIndex: 1,
    color: theme.palette.text.secondary,
  },
}));
